import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
} from "@mui/material";
import { useState } from "react";
import pagamentosService from "../services/pagamentos";
import {
  UPLOAD_PRESETS,
  validateUploadFile,
} from "../utils/validateUploadFile";
import ConfirmacaoDigitandoModal from "./ConfirmacaoDigitandoModal";

const UploadComprovantePagamentoModal = ({
  open,
  onClose,
  boleto,
  onComprovanteEnviado,
}) => {
  const [arquivo, setArquivo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleArquivoChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    e.target.value = "";

    const resultado = await validateUploadFile(file, UPLOAD_PRESETS.pagamento);
    if (!resultado.valid) {
      setError(resultado.error);
      setArquivo(null);
      return;
    }
    setError("");
    setArquivo(file);
  };

  const executarEnvio = async () => {
    try {
      setError("");
      setSuccess("");
      setLoading(true);

      await pagamentosService.uploadComprovante(
        boleto.id,
        boleto.solicitacaoId,
        arquivo,
      );

      setSuccess("Comprovante enviado com sucesso!");
      setConfirmOpen(false);

      if (onComprovanteEnviado) {
        await onComprovanteEnviado();
      }

      setTimeout(() => {
        setArquivo(null);
        onClose();
      }, 1500);
    } catch (err) {
      setConfirmOpen(false);
      setError(
        err?.response?.data?.message ||
          err?.message ||
          "Erro ao enviar comprovante. Tente novamente.",
      );
    } finally {
      setLoading(false);
    }
  };

  const handleEnviar = () => {
    setError("");
    setSuccess("");

    if (!boleto) {
      setError("Boleto não informado.");
      return;
    }

    if (!arquivo) {
      setError("Selecione o arquivo do comprovante.");
      return;
    }

    setConfirmOpen(true);
  };

  const handleFechar = () => {
    if (!loading) {
      setArquivo(null);
      setError("");
      setSuccess("");
      setConfirmOpen(false);
      onClose();
    }
  };

  return (
    <>
      <Dialog open={open} onClose={handleFechar} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ pb: 1 }}>Enviar Comprovante de Pagamento</DialogTitle>
        <Divider />
        <DialogContent sx={{ pt: 3 }}>
          {boleto && (
            <Alert severity="info" sx={{ mb: 3 }}>
              <Typography variant="body2" component="div">
                <strong>Boleto:</strong>{" "}
                {boleto.descricao || boleto.fileName || "Boleto"}
                <br />
                <strong>Arquivo:</strong> {boleto.fileName}
              </Typography>
            </Alert>
          )}

          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}
          {success && (
            <Alert severity="success" sx={{ mb: 2 }}>
              {success}
            </Alert>
          )}

          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <Button variant="outlined" component="label" disabled={loading}>
              {arquivo
                ? arquivo.name
                : "Selecionar Comprovante (PDF, JPG, PNG)"}
              <input
                type="file"
                accept="application/pdf,image/jpeg,image/png,image/jpg"
                hidden
                onChange={handleArquivoChange}
              />
            </Button>
            {arquivo && (
              <Typography variant="caption" color="text.secondary">
                {(arquivo.size / 1024 / 1024).toFixed(2)} MB
              </Typography>
            )}
          </Box>
        </DialogContent>

        <DialogActions sx={{ mt: 2, justifyContent: "flex-end", gap: 1 }}>
          <Button onClick={handleFechar} disabled={loading}>
            Cancelar
          </Button>
          <Button
            onClick={handleEnviar}
            variant="contained"
            color="secondary"
            disabled={loading}
          >
            Enviar Comprovante
          </Button>
        </DialogActions>
      </Dialog>

      <ConfirmacaoDigitandoModal
        open={confirmOpen}
        onClose={() => !loading && setConfirmOpen(false)}
        onConfirm={executarEnvio}
        tipoDocumento="Comprovante"
        loading={loading}
      />
    </>
  );
};

export default UploadComprovantePagamentoModal;
